




import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/card.vue";

@Component({
  components: { Card }
})
export default class CardView extends Vue {
  @Prop() cardValue!: number;

  goBack() {
    return this.$router.go(-1);
  }
}
